














































import { Vue, Component, Prop } from 'vue-property-decorator'
import { EntryAllCfg } from '@/types/newPersion'
@Component
export default class BottomCard extends Vue {
  @Prop() entryAllCfg!: EntryAllCfg;
  @Prop() getTopChartAndTableFn!: Function;
  private handleEditBtn (status: string, idx: number) {
    this.$emit('on-edit-btn', status, idx)
  }
}
